import { reactive } from "vue";

export type ConnectionConfig = {
  baseUrl: string;
  clientKey: string;
};

const adminStorageKey = "matttest-admin-console-config";
const clientStorageKey = "matttest-interaction-client-config";
const legacyStorageKey = "matttest-console-config";

function readStored(storageKey: string): Partial<ConnectionConfig> {
  try {
    const stored = localStorage.getItem(storageKey);
    return stored ? JSON.parse(stored) as Partial<ConnectionConfig> : {};
  } catch {
    return {};
  }
}

function readLegacy(): Partial<ConnectionConfig> {
  try {
    const stored = sessionStorage.getItem(legacyStorageKey);
    return stored ? JSON.parse(stored) as Partial<ConnectionConfig> : {};
  } catch {
    return {};
  }
}

const legacy = readLegacy();
const adminStored = readStored(adminStorageKey);
const clientStored = readStored(clientStorageKey);
const defaultBaseUrl = import.meta.env.VITE_SERVICE_BASE_URL ?? "";
const defaultClientKey = import.meta.env.VITE_CLIENT_KEY ?? "";

export const adminConfig = reactive<ConnectionConfig>({
  baseUrl: adminStored.baseUrl ?? legacy.baseUrl ?? defaultBaseUrl,
  clientKey: adminStored.clientKey ?? legacy.clientKey ?? defaultClientKey,
});

export const clientConfig = reactive<ConnectionConfig>({
  baseUrl: clientStored.baseUrl ?? legacy.baseUrl ?? defaultBaseUrl,
  clientKey: clientStored.clientKey ?? legacy.clientKey ?? defaultClientKey,
});

export const activeConfig = window.location.pathname.startsWith("/client") ? clientConfig : adminConfig;

function persist(target: ConnectionConfig, storageKey: string, next: ConnectionConfig): void {
  target.baseUrl = next.baseUrl.trim().replace(/\/$/, "");
  target.clientKey = next.clientKey.trim();
  localStorage.setItem(storageKey, JSON.stringify(target));
  sessionStorage.removeItem(legacyStorageKey);
}

export function saveAdminConfig(next: ConnectionConfig): void {
  persist(adminConfig, adminStorageKey, next);
}

export function saveClientConfig(next: ConnectionConfig): void {
  persist(clientConfig, clientStorageKey, next);
}
